import { useContext, useEffect, useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import ComponentLoader from "./ComponentLoader";

/**
 * Layout guard for /pilot/*. Requires login before any pilot screen renders.
 * Unauthenticated users are sent to /pilot/login (not /auth) so pilot and main flows stay separate.
 */
function RequirePilotAuth() {
  const { isUserLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const ok = await isUserLoggedIn();
      if (cancelled) return;
      if (!ok) {
        navigate("/pilot/login", {
          replace: true,
          state: { redirectTo: "/pilot/home" },
        });
        return;
      }
      setAllowed(true);
    })();

    return () => {
      cancelled = true;
    };
    // Run once when entering the pilot section so in-flow navigation
    // (e.g. products → product detail) does not flash the loader again.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!allowed) {
    return <ComponentLoader />;
  }

  return <Outlet />;
}

export default RequirePilotAuth;
